import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import LoadingSpinner from '../components/common/LoadingSpinner';
import PageContentBlocks from '../components/common/PageContentBlocks';
import usePageContent from '../hooks/usePageContent';
import { tipsAPI } from '../services/api';

export default function TipsPage() {
  const { t, i18n } = useTranslation();
  const { blocks } = usePageContent('tips', i18n.language);
  const [tips, setTips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    tipsAPI.getAll({ language: i18n.language }).then((res) => setTips(res.data.data)).finally(() => setLoading(false));
  }, [i18n.language]);

  return (
    <>
      <SEO title={t('tips.title')} description={t('tips.subtitle')} />
      <section className="py-12 px-4 max-w-4xl mx-auto">
        <h1 className="section-title mb-2">{t('tips.title')}</h1>
        <p className="text-gray-500 mb-6">{t('tips.subtitle')}</p>
        <PageContentBlocks blocks={blocks} className="mb-10" />
        {loading ? <LoadingSpinner className="py-20" /> : (
          <div className="space-y-4">
            {tips.map((tip, i) => (
              <motion.div key={tip.id} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}
                className="card border-l-4 border-l-brand-500">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">💡</span>
                  <div>
                    <h3 className="font-bold text-lg">{tip.title}</h3>
                    <p className="text-gray-600 dark:text-gray-400 mt-2">{tip.content}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
